module.exports = (__webpack_require__(7686))(961);